// extracted by mini-css-extract-plugin
module.exports = {"modal__header":"customModal_modal__header__2gZst","rightSubHeader":"customModal_rightSubHeader__y0cmp"};